import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServiciosPage.css';

const ServiciosPage = () => {
  const allServices = [
    {
      icon: '🧹',
      title: 'Limpieza',
      description: 'Servicios integrales de limpieza corporativa, hospitalaria, industrial, educativa y hotelera con productos ecológicos certificados.',
      features: ['Limpieza Corporativa', 'Limpieza Hospitalaria', 'Limpieza Industrial', 'Limpieza Educativa'],
      link: '/servicios/limpieza',
      image: '/images/limpieza-principal.jpeg'
    },
    {
      icon: '👥',
      title: 'Servicios Auxiliares',
      description: 'Personal especializado y capacitado para servicios de recepción, seguridad, logística y apoyo operacional.',
      features: ['Recepción y Atención', 'Seguridad', 'Logística', 'Servicios Generales'],
      link: '/servicios/auxiliares',
      image: '/images/auxiliares-principal.jpeg'
    },
    {
      icon: '🔧',
      title: 'Mantenimiento e Ingeniería',
      description: 'Soluciones completas de mantenimiento preventivo y correctivo para instalaciones industriales y corporativas.',
      features: ['Mantenimiento Preventivo', 'Mantenimiento Correctivo', 'Ingeniería de Instalaciones', 'Gestión de Activos'],
      link: '/servicios/mantenimiento',
      image: '/images/mantenimiento-principal.jpg'
    },
    {
      icon: '💼',
      title: 'Recursos Humanos',
      description: 'Gestión integral del capital humano: reclutamiento, selección, capacitación y administración de personal.',
      features: ['Reclutamiento', 'Selección', 'Capacitación', 'Administración de Personal'],
      link: '/servicios/rrhh',
      image: '/images/rrhh-principal.jpg'
    },
    {
      icon: '🏥',
      title: 'Servicios Sociosanitarios',
      description: 'Atención especializada para centros de salud, clínicas y residencias con los más altos estándares de calidad.',
      features: ['Atención Sanitaria', 'Protocolos Certificados', 'Personal Especializado', 'Bioseguridad'],
      link: '/servicios/sociosanitarios',
      image: '/images/sociosanitarios-principal.jpg'
    },
    {
      icon: '✨',
      title: 'Soluciones Integrales',
      description: 'Servicios combinados y personalizados que integran múltiples áreas para ofrecer soluciones completas a su medida.',
      features: ['Servicios Combinados', 'Soluciones Personalizadas', 'Gestión Integral', 'Facility Management'],
      link: '/servicios/soluciones-integrales',
      image: '/images/soluciones-principal.jpg'
    }
  ];

  return (
    <div className="servicios-page">
      <section
        className="page-hero"

      >
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <p className="page-hero-tagline">Lo que ofrecemos</p>
          <h1>Nuestros Servicios</h1>
          <p>Soluciones profesionales para cada necesidad de su empresa</p>
        </div>
      </section>

      <section className="servicios-intro">
        <div className="container">
          <h2>Experiencia y Compromiso en Cada Servicio</h2>
          <p>
            En Ecolimpieza Perú A&G S.A.C. ofrecemos una amplia gama de servicios especializados
            diseñados para satisfacer las necesidades específicas de cada sector. Con más de 15 años
            de experiencia, nuestro compromiso es brindar soluciones de calidad con responsabilidad
            ambiental y social.
          </p>
        </div>
      </section>

      <section className="servicios-grid-section">
        <div className="container">
          {allServices.map((service, index) => (
            <div key={index} className="service-detail-card">
              <div className="service-detail-image">
                <img
                  src={service.image}
                  alt={service.title}
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300"%3E%3Crect fill="%230D3B66" width="400" height="300"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="white" font-size="60"%3E' + service.icon + '%3C/text%3E%3C/svg%3E';
                  }}
                />
                <div className="service-icon-overlay">{service.icon}</div>
              </div>
              <div className="service-detail-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx}>✓ {feature}</li>
                  ))}
                </ul>
                <Link to={service.link} className="btn-primary">
                  Ver Detalles Completos
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="servicios-cta">
        <div className="container">
          <h2>¿Necesita una solución personalizada?</h2>
          <p>Contáctenos y diseñaremos un plan de servicios adaptado a sus necesidades específicas</p>
          <Link to="/contacto" className="btn-white">Solicitar Cotización</Link>
        </div>
      </section>
    </div>
  );
};

export default ServiciosPage;
